import baseApi from '../utils/ApiUtils';

export const researchApi = (method, payload = null, params = null) => {
  return baseApi(`/materials/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const researchAction = (method, id, payload = null, params = null) => {
  return baseApi(`/materials/${id}`, method, params, payload).then(response => {
    return response.data;
  });
};